// src/components/location/Map.js
import React from 'react';

const Map = () => {
  return (
    <div className="relative w-full h-full bg-white rounded-2xl shadow-xl overflow-hidden">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2324.4051332292287!2d18.605993377259785!3d54.38247497982466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fd74975a38eb91%3A0x6c11845577ca7c9c!2sMatuszewskiego%2011%2C%2080-288%20Gda%C5%84sk!5e0!3m2!1spl!2spl!4v1706513339811!5m2!1spl!2spl"
        className="w-full h-full border-0"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Lokalizacja myjni MDClean"
        aria-label="Mapa pokazująca lokalizację myjni MDClean w Gdańsku"
      />
    </div>
  );
};

export default Map;
